import Vue from 'vue'
import router from './router'
import App from './App.vue'

// CSS framework
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy, {
    defaultIconPack: 'fas'
});

// Axios config
// Axios global config
import axios from 'axios'

const axiosConfig = {
    // baseURL: '/api/api/',  // Set URL for API
    baseURL: process.env.VUE_APP_AXIOSBASEURL,  // Set URL for API
    timeout: process.env.VUE_APP_AXIOSTIMEOUT,  // Set timeout
    withCredentials: true,
    params: {
        db: localStorage.getItem("dbSelected")
    }
};
// Setting up Axios on Vue Instance, for use via this.$axios
// Vue.prototype.$axios = axios.create(axiosConfig);
Vue.prototype.$axios = axios.create(axiosConfig); // Without Bearer for login
// Add db info
// Vue.prototype.$axios.defaults.params = {}
// Vue.prototype.$axios.defaults.params['db'] = localStorage.getItem("dbSelected")

// Timeout
Vue.prototype.$axios.defaults.timeout = 120000;

// Interceptor for expired token (error 401)
Vue.prototype.$axios.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response.status == 403) {
        router.push('/').catch(() => {
        })
    }
    return Promise.reject(error);
});

// Global functions
// Round to the near 0.5 value
Vue.mixin({
    methods: {
        checkStringChar: function (string) {
            let regex = /[;()\\/]/;  // Regular expression to match the special characters
            return !regex.test(string);
        },
        roundHalf: function (num) {
            return Math.round(num * 2) / 2;
        },
        roundTwoDigits: function (n, digits) {
            let negative = false;
            if (digits === undefined) {
                digits = 0;
            }
            if (n < 0) {
                negative = true;
                n = n * -1;
            }
            let multiplicator = Math.pow(10, digits);
            n = parseFloat((n * multiplicator).toFixed(11));
            n = (Math.round(n) / multiplicator).toFixed(digits);
            if (negative) {
                n = (n * -1).toFixed(digits);
            }
            return n;
        },
        addSpace: function (n, spreadsheet = false) {
            if (spreadsheet) {
                let f = parseFloat(n).toString();
                return f.replace('.', ',')
            } else {
                return parseFloat(n).toLocaleString('fr');
            }

        },
        // Sum all value of all key
        sumObj: function (obj) {
            let total = 0;
            for (let property in obj) {
                total += obj[property];
            }
            return total;
        },

    }
})

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
